import React, { useState, FC, FocusEvent, ChangeEvent } from 'react'

import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types'
import { MultiLineStringInputViewModel } from '@sitecore-jss/sitecore-jss-forms'

const MultipleLineTextField: FC<
  ValueFieldProps<MultiLineStringInputViewModel>
> = (props) => {
  const {
    field,
    value,
    errors,
    tracker,
    isValid,
    fieldValidationErrorsComponent,
    onChange,
  } = props

  const [hasFocus, setHasFocus] = useState(false)

  const FieldValidationErrors = fieldValidationErrorsComponent

  const hasValueOrFocus = hasFocus || value !== ''
  const hasAnyError = !!errors?.length
  const label = field.model.title
  const id = field.valueField.id
  const name = field.valueField.name
  const rows = field.model.rows
  const maxLength = field.model.maxLength ? field.model.maxLength : 255

  const onFocus = (e: FocusEvent<HTMLTextAreaElement>) => {
    tracker.onFocusField(field, e.target.value)
    setHasFocus(true)
  }

  const onBlur = (e: FocusEvent<HTMLTextAreaElement>) => {
    tracker.onBlurField(field, e.target.value)
    setHasFocus(false)
  }

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    onChange(field.valueField.name, e.target.value, isValid, [])
  }

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <label
        htmlFor={id}
        className={`sitecore-jss-form__label ${
          hasValueOrFocus ? 'sitecore-jss-form__label--has-focus' : ''
        }`}
      >
        {label}
      </label>
      <textarea
        rows={rows}
        maxLength={maxLength}
        id={id}
        name={name}
        className="sitecore-jss-form__field sitecore-jss-form__field--text-area"
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={handleChange}
      >
        {value}
      </textarea>

      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  )
}

export default MultipleLineTextField
